import Vue from 'vue'
import VueMeta from 'vue-meta'
import App from './App.vue'
import router from './router'
import store from './store'
import axios from 'axios'
import i18n from './i18n'
import moment from 'moment'
import _ from 'lodash'
import { v4 as uuidv4 } from 'uuid'
import { Datetimepicker, Datepicker, Input, Icon } from 'buefy'
import isMobile from '@/plugins/isMobile'
import scrollReveal from '@/plugins/scroll-reveal'
import { scroll, resize, accordeon, clickOutside } from '@/directives'

Vue.config.productionTip = false

const axiosInstance = axios.create({
  baseURL: process.env.VUE_APP_API
})

// handle token expire
axiosInstance.interceptors.response.use((response) => response, (err) => {
  return new Promise((resolve, reject) => {
    if ('code' in err.response.data &&
      err.response.data.code === 'token_not_valid' &&
      err.config.url !== '/auth/token/refresh/'
    ) {
      console.log(err.config)
      store.dispatch('user/refreshToken')
        .then((auth) => {
          err.config.headers.Authorization = `Bearer ${auth.access}`
          axiosInstance.request(err.config)
            .then((response) => resolve(response))
        })
    } else {
      reject(err)
    }
  })
})

// обработка обшибки 401, 403 - когда токен закончился, если рефреш истек - редирект на логин + реджект
axiosInstance.interceptors.response.use(response => {
  // Return a successful response back to the calling service
  return response
}, error => {
  // если это не ошибка 401 или 403 И код ответа не token_not_valid, то вызываем ошибку
  if (!([401, 403].includes(error.response.status) && error.response.data && error.response.data.code === 'token_not_valid')) {
    return Promise.reject(error)
  }

  // Logout user if token refresh didn't work or user is disabled
  if (error.config.url === '/auth/token/refresh/') {
    store.dispatch('user/logout')
    router.push('/login')

    return Promise.reject(error)
  }

  // Try request again with new token
  return store.dispatch('user/refreshToken')
    .then((data) => {
      // New request with new token
      const config = error.config
      config.headers.Authorization = `Bearer ${data.access}`

      return new Promise((resolve, reject) => {
        axiosInstance.request(config).then(response => {
          resolve(response)
        }).catch((error) => {
          reject(error)
        })
      })
    })
    .catch((error) => {
      Promise.reject(error)
    })
})

moment.locale('ru')

// prototype sections
Vue.prototype.$axios = axiosInstance
Vue.prototype.$moment = moment
Vue.prototype.$_ = _
Vue.prototype.$uuid = uuidv4

// use sections
Vue.use(VueMeta)
Vue.use(Datetimepicker)
Vue.use(Datepicker)
Vue.use(Input)
Vue.use(Icon)
Vue.use(isMobile)
Vue.use(scrollReveal)

// global directives
Vue.directive('focus', {
  // Когда привязанный элемент вставлен в DOM...
  inserted: function (el) {
    // Переключаем фокус на элемент
    el.focus()
  }
})
Vue.directive('scroll', scroll)
Vue.directive('resize', resize)
Vue.directive('accordeon', accordeon)
Vue.directive('click-outside', clickOutside)

// components
Vue.component('Input-select', () => import('@/components/input/select.vue'))

new Vue({
  router,
  store,
  i18n,
  render: h => h(App)
}).$mount('#app')
